export enum FormMcaOnlineReportTypeEnum {
  MONTHLY = "Monthly",
  DAILY = "Daily",
  CUSTOMIZE = "Customize",
  TEST_REPORT = "Test report",
}

export enum FormRvsOnlineReportTypeEnum {
  DAILY = "Daily",
}

interface UserItem {
  id: string;
  email: string;
  isNotify: boolean;
  name: string;
  profileImageUrl: string;
  role: string;
  status: string;
}

export interface OnlineReportEmailList {
  items: UserItem[];
  page: number;
  size: number;
  total: number;
}
